import React from 'react';
import { Box, Typography, Button, alpha, useTheme } from '@mui/material';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link, useNavigate } from 'react-router-dom';
import { COMPILER_LANGUAGES } from '../common/compilerLanguages';
import CompilerLanguagePicker from './CompilerLanguagePicker';

const ACCENT = '#137274';

const IdeLanguageCallout = ({ sx = {} }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isDark = theme.palette.mode === 'dark';
  const border = isDark ? '#30363d' : 'rgba(15, 60, 70, 0.1)';
  const muted = isDark ? '#8b949e' : '#5f6b73';

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 2.5 },
        borderRadius: 3,
        border: `1px solid ${alpha(ACCENT, 0.28)}`,
        bgcolor: isDark ? '#161b22' : '#fff',
        background: isDark
          ? `radial-gradient(520px 200px at 0% 0%, ${alpha(ACCENT, 0.22)}, transparent 60%), #161b22`
          : `radial-gradient(520px 200px at 0% 0%, ${alpha(ACCENT, 0.1)}, transparent 60%), #fff`,
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 1.75, flexWrap: 'wrap' }}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: 2,
            display: 'grid',
            placeItems: 'center',
            bgcolor: alpha(ACCENT, isDark ? 0.22 : 0.1),
            color: ACCENT,
            flexShrink: 0,
          }}
        >
          <CodeOutlinedIcon />
        </Box>
        <Box sx={{ flex: 1, minWidth: 220 }}>
          <Typography sx={{ fontWeight: 900, fontSize: '1.15rem', letterSpacing: '-0.02em', mb: 0.35 }}>
            Online compiler · {COMPILER_LANGUAGES.length} languages
          </Typography>
          <Typography variant="body2" sx={{ color: muted, lineHeight: 1.5, maxWidth: 560 }}>
            Write, run, and share code in the browser — Python, Java, C++, JavaScript, Go, Rust,
            TypeScript, and more. No install required.
          </Typography>
        </Box>
        <Button
          component={Link}
          to="/ide"
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          sx={{
            textTransform: 'none',
            fontWeight: 800,
            bgcolor: ACCENT,
            flexShrink: 0,
            '&:hover': { bgcolor: '#0f5c5e' },
          }}
        >
          Open IDE
        </Button>
      </Box>

      <Typography
        sx={{
          fontSize: '0.68rem',
          fontWeight: 800,
          letterSpacing: '0.07em',
          textTransform: 'uppercase',
          color: muted,
          mb: 1,
        }}
      >
        Pick a language
      </Typography>
      <CompilerLanguagePicker
        languages={COMPILER_LANGUAGES}
        value="python"
        onChange={(id) => navigate(`/ide/${id}`)}
        size="compact"
      />
    </Box>
  );
};

export default IdeLanguageCallout;
